import { useContext, useState } from 'react';

import Button from '../../../reusable/button/button.component.jsx';
import Spinner from '../../../reusable/spinner/spinner.component.jsx';

import { ToastContext } from '../../../../contexts/toast.context.jsx';
import { UserContext } from '../../../../contexts/user.context.jsx';

import sectionComponentMap from './index.js';

import {
  DeleteButton,
  Input,
  MainContainer,
  Option,
  RowContainer,
  Select,
  Title
} from '../../../../styles/component.styles.jsx';

const UpdateSection = ({ section, submit, deleteSection, showUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(section.title);
  const [type, setType] = useState(section.type);
  const [position, setPosition] = useState(section.position);
  const [content, setContent] = useState(section.content);
  const [metadata, setMetadata] = useState(section.metadata);
  const [files, setFiles] = useState([]);

  const { errorToast } = useContext(ToastContext);
  const { currentUser } = useContext(UserContext);

  const handleTypeChange = (newType) => {
    setType(newType);
    setContent({});
    setMetadata({});
    setFiles([]);
  };

  const SectionConfig = sectionComponentMap[type];
  const SectionComponent = SectionConfig?.component || null;

  const submitUpdate = async () => {
    if (!type || !title) {
      errorToast('Please fill out all fields to update section.');
      return;
    }

    setLoading(true);
    const data = {
      pageId: section.pageId,
      title,
      type,
      content,
      position,
      metadata,
      files
    };

    await submit(data);
    setLoading(false);
  };

  return (
    <MainContainer>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Title>Update Section</Title>

          <Input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title"
          />

          <Select value={type} onChange={(e) => handleTypeChange(e.target.value)}>
            <Option value="" disabled> -- select type -- </Option>
            {Object.entries(sectionComponentMap).map(([key, config]) => (
              <Option key={key} value={key}>{config.name}</Option>
            ))}
          </Select>

          <Input
            type="number"
            value={position}
            onChange={(e) => setPosition(parseInt(e.target.value) || 0)}
            placeholder="Position"
          />

          {SectionComponent && (
            <SectionComponent
              content={content}
              metadata={metadata}
              onChange={({ content, metadata, files = [] }) => {
                setContent(content);
                setMetadata(metadata);
                setFiles(files);
              }}
            />
          )}

          <RowContainer margin={'10px 0'}>
            <Button onClick={() => showUpdate(false)}>Cancel</Button>
            <Button onClick={submitUpdate}>Confirm</Button>
          </RowContainer>
          <RowContainer>
            <DeleteButton onClick={deleteSection}>DELETE</DeleteButton>
          </RowContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateSection;